import PropTypes from 'prop-types';

export default {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  publishDate: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  sortPosition: PropTypes.number,
  featured: PropTypes.bool.isRequired,
}